import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        // Retrieve referral slug persisted when user visited the referral landing page
        const storedSlug = localStorage.getItem('perkly_referral_slug');
        const storedTs   = parseInt(localStorage.getItem('perkly_referral_ts') || '0', 10);
        const referredBySlug = (storedSlug && (Date.now() - storedTs) < 7 * 24 * 60 * 60 * 1000)
          ? storedSlug
          : null;

        const res = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId, referred_by_slug: referredBySlug })
        });

        if (!res.ok) throw new Error('Session exchange failed');

        const data = await res.json();
        setUser(data.user);

        // Clear referral slug after successful signup (backend handles dedup for existing users)
        localStorage.removeItem('perkly_referral_slug');
        localStorage.removeItem('perkly_referral_ts');

        // If user arrived from a business referral QR, always land on homepage (logged-in)
        const role = data.user?.role;
        if (storedSlug) {
          navigate('/', { replace: true });
        } else if (role === 'admin') {
          navigate('/admin', { replace: true });
        } else if (role === 'business') {
          navigate('/business/dashboard', { replace: true });
        } else {
          navigate('/student/dashboard', { replace: true });
        }

      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#F6F1E9] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#C8A97E] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-montserrat text-[#2B2B2B]/60">Signing you in...</p>
      </div>
    </div>
  );
}
